import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {OrderEntry} from '@spartacus/cart/base/root';
import {CheckoutStepService} from '@spartacus/checkout/base/components';
import {RoutingConfigService} from '@spartacus/core';
import {combineLatest, Observable} from 'rxjs';
import {filter, map} from 'rxjs/operators';
import {DcpActiveCartService} from '../../services/dcp-active-cart.service';
import {TransactionTypeService} from '../../services/transactionTypes/transaction-type.service';
import {TransactionTypeDataService} from '@app/services/transactionTypes/transaction-type-data.service';
import {isEmpty} from '@spartacus/cart/base/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicCheckoutStepSelectionGuard {
  constructor(
    private dcpActiveCartService: DcpActiveCartService,
    private transactionTypeService: TransactionTypeService,
    private transactionTypeDataService: TransactionTypeDataService,
    private routingConfigService: RoutingConfigService,
    private router: Router,
    private checkoutStepService: CheckoutStepService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return combineLatest([
      this.dcpActiveCartService.getLoading(),
      this.dcpActiveCartService.getActiveCart(),
      this.transactionTypeService.getTransactionTypes$(),
      this.checkoutStepService.steps$,
    ]).pipe(
      filter(([loading, cart]) => !loading && !isEmpty(cart)),
      map(([loading, cart, transactionTypes, steps]) => {
        if (cart?.entries && cart.entries.length && transactionTypes?.length && steps?.length) {
          let step: string;
          let highestPriority: number = -1;

          cart.entries.forEach((cartEntry: OrderEntry) => {
            const foundTransactionType = transactionTypes.find(
              (transactionType) => cartEntry.transactionType === transactionType.code
            );
            const actions = this.transactionTypeDataService.getActions(foundTransactionType?.data);
            if (actions?.length) {
              actions.forEach((action) => {
                if (action.priority > highestPriority) {
                  highestPriority = action.priority;
                  step = action.pageId;
                }
              });
            }
          });

          const foundStep = steps.find((checkoutStep) => checkoutStep.id === step);
          if (foundStep) {
            return this.router.parseUrl('/' + this.routingConfigService.getRouteConfig(foundStep.routeName).paths[0]);
          }
        }
        // fallback routing
        return this.router.parseUrl('/checkout/review-order');
      })
    );
  }
}
